"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var browser_1 = require("@sentry/browser");
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var core_2 = require("@21st-night/core");
var Button_1 = __importDefault(require("../../Button"));
exports.useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        content: {
            minWidth: 300,
        },
    });
});
var ImportCardsDialog = function (_a) {
    var onClose = _a.onClose, other = __rest(_a, ["onClose"]);
    var classes = exports.useStyles();
    var functions = core_2.useFirebase().functions;
    var deck = core_2.useDeck();
    var decks = core_2.useUser().decks;
    var _b = __read(react_1.useState(false), 2), loading = _b[0], setLoading = _b[1];
    var _c = __read(react_1.useState(''), 2), error = _c[0], setError = _c[1];
    var _d = __read(react_1.useState(null), 2), importCounts = _d[0], setImportCounts = _d[1];
    var _e = core_2.useFormField(''), importDeck = _e.value, onImportDeckChange = _e.onChange, clearImportDeck = _e.clear;
    // Initialize duplicateDeckCards Firebase function
    var duplicateDeckCards = functions.httpsCallable('duplicateDeckCards');
    var copyCards = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var counts, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setError('');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, duplicateDeckCards({
                            sourceDeckId: importDeck,
                            destinationDeckId: deck.id,
                        })];
                case 2:
                    counts = _a.sent();
                    setImportCounts(counts.data);
                    clearImportDeck();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    browser_1.captureException(error_1);
                    setError(error_1.message);
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [importDeck, deck.id, clearImportDeck, duplicateDeckCards]);
    return (react_1.default.createElement(core_1.Dialog, __assign({ onClose: onClose, maxWidth: "xs" }, other),
        react_1.default.createElement(core_1.DialogTitle, null, "Import cards"),
        react_1.default.createElement(core_1.DialogContent, { className: classes.content },
            error && react_1.default.createElement(core_1.Typography, { color: "error" },
                "Error: ",
                error),
            importCounts && importCounts.cards > 0 && (react_1.default.createElement(core_1.Typography, null,
                importCounts.cards,
                " cards imported")),
            !importCounts && (react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(core_1.Typography, { gutterBottom: true, variant: "body2", color: "textSecondary" }, "Copy the cards, categories, and subcategories from another deck into this deck."),
                react_1.default.createElement(core_1.Select, { name: "copy-from-deck", displayEmpty: true, value: importDeck, onChange: onImportDeckChange, disabled: loading },
                    react_1.default.createElement(core_1.MenuItem, { value: "", disabled: true }, "Select a deck"),
                    decks
                        .filter(function (_a) {
                        var id = _a.id, cards = _a.cards;
                        return id !== deck.id && cards.length > 0;
                    })
                        .map(function (targetDeck) { return (react_1.default.createElement(core_1.MenuItem, { key: targetDeck.id, value: targetDeck.id }, targetDeck.name)); })),
                loading && ' Importing...'))),
        react_1.default.createElement(core_1.DialogActions, null,
            !importCounts && (react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(Button_1.default, { onClick: onClose }, "Cancel"),
                react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: copyCards, disabled: !importDeck || loading }, "Import"))),
            importCounts && (react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: onClose }, "Close")))));
};
exports.default = ImportCardsDialog;
//# sourceMappingURL=ImportCardsDialog.js.map